export default __webpack_public_path__ + "static/media/file-import-outline.82c54088.svg";